<template>
	<!-- Bank Account Form -->
	<modal class="integration-modal" :size="'medium'" v-if="show" @close="close">
		<div slot="header"><h3><i class="material-icons">account_balance</i>Bank Information</h3></div>
		<div slot="body">
			<div class="integration-actions">
				<div class="form-group">
					<label><b>Bank</b></label>
					<multiselect
						class="form-control"
						track-by="name"
						label="label"
						:options="banks"
						:show-labels="false"
						:preselect-first="true"
						:allow-empty="false"
						v-model="bank">
					</multiselect>
				</div>
				<div class="form-group">
					<label><b>Account Name</b></label>
					<input type="text" name="account_name" class="form-control" placeholder="Account Name.." v-model="accountName" required>
				</div>
				<div class="form-group">
					<label><b>Account Number</b></label>
					<input type="text" name="account_number" class="form-control" placeholder="Account Number.." v-model="accountNumber" required>
				</div>
			</div>
		</div>
		<div slot="footer">
			<button type="button" class="btn btn-primary" :class="{ 'is-loading': isSaving }" @click="add">Add New Bank Account</button>
		</div>
	</modal>
</template>

<script>
import { mapActions } from 'vuex';
import Modal from './Modal.vue';
import { banks } from '../lib/statics';

export default {
	name: 'bankAccountsModal',
	props: {
		show: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		Modal,
	},
	data() {
		return {
			banks,
			bank: null,
			accountName: '',
			accountNumber: '',
			isSaving: false,
		};
	},
	methods: {
		...mapActions({
			addBankAccount: 'addBankAccount',
			removeBankAccount: 'removeBankAccount',
		}),
		reset() {
			this.accountName = '';
			this.accountNumber = '';
		},
		close() {
			this.$emit('close');
		},
		isValid() {
			const isValid = this.accountName !== '' && this.accountNumber !== '';
			return isValid;
		},
		add() {
			if (this.isValid && this.bank) {
				this.isSaving = true;
				const bankAccount = {
					name: this.bank.name,
					label: this.bank.label,
					account_name: this.accountName,
					account_number: this.accountNumber,
				};
				const cb = () => {
					this.isSaving = false;
					this.reset();
					this.close();
				};
				const errorCb = () => {
					this.isSaving = false;
					this.reset();
				};
				this.addBankAccount({ bankAccount, cb, errorCb });
			}
		},
		remove(index) {
			this.isSaving = true;
			const cb = () => {
				this.isSaving = false;
			};
			const errorCb = () => {
				this.isSaving = false;
			};
			this.removeBankAccount({ index, cb, errorCb });
		},
	},
};
</script>
